/*
 * closeEproDevicePopupComponent
 * */

import templateUrl from './closeEproDevicePopup.html';
import controller from './closeEproDevicePopup.controller';
import './closeEproDevicePopup.scss';

const closeEproDevicePopupComponent = {
	bindings: {
		componentReady: '&'
	},
	templateUrl,
	controller
};

export default closeEproDevicePopupComponent;
